import axios from "axios";
import { api } from "~/router/apiConfig";

export function list() {
  return axios.get(api.path("userReferralCounterparty.index"), null);
}
